import { render, staticRenderFns } from "./GroupGuideList.vue?vue&type=template&id=c5b0f456"
import script from "./GroupGuideList.vue?vue&type=script&lang=js"
export * from "./GroupGuideList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports